
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import {windVane} from '../../utils/tmallGenius';
export default {
components: {Group, CellBox, Cell,},
data() {
return {
isShowDrawDownMenu: false,
};
},
methods: {
/*------------------------------------------- 绑定函数 -------------------------------------------------------*/
/*  翻转显示
* */
toggleIsShowDrawDownMenu() {
this.isShowDrawDownMenu = !this.isShowDrawDownMenu;
},
/*  显示确认框
* */
showConfirm() {
let _this = this;
this.$vux.confirm.show({
title: '提示',
content: '解除【ORVIBO】账号绑定，将无法再使用相关服务。',
onCancel() {
_this.toggleIsShowDrawDownMenu();
},
onConfirm() {
windVane.unbind();  //解除绑定
}
})
},
}
};



// WEBPACK FOOTER //
// ./src/pages/Home/topMenu.vue